import { render, staticRenderFns } from "./CatalogProductsPage.vue?vue&type=template&id=4ca73fb2"
import script from "./CatalogProductsPage.vue?vue&type=script&lang=js"
export * from "./CatalogProductsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports